export function downloadDocument(documentUri: string | null | undefined, filename?: string) {
  if (!documentUri) {
    throw new Error("Cannot download a document without a URL.");
  }

  const link = document.createElement("a");
  link.href = documentUri;
  link.download = filename || "";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
